/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MobileRouteImport } from './routes/mobile'
import { Route as PairRouteImport } from './routes/pair'
import { Route as PairMachineRouteImport } from './routes/pair-machine'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as ChatAutomationsRouteImport } from './routes/_chat.automations'
import { Route as ChatNewRouteImport } from './routes/_chat.new'
import { Route as ChatPluginsRouteImport } from './routes/_chat.plugins'
import { Route as ChatPullRequestsRouteImport } from './routes/_chat.pull-requests'
import { Route as SettingsAboutRouteImport } from './routes/settings.about'
import { Route as SettingsAgentContextRouteImport } from './routes/settings.agent-context'
import { Route as SettingsAgentWorkflowRouteImport } from './routes/settings.agent-workflow'
import { Route as SettingsAgentsRouteImport } from './routes/settings.agents'
import { Route as SettingsAppearanceRouteImport } from './routes/settings.appearance'
import { Route as SettingsArchivedRouteImport } from './routes/settings.archived'
import { Route as SettingsBrowserRouteImport } from './routes/settings.browser'
import { Route as SettingsChatRouteImport } from './routes/settings.chat'
import { Route as SettingsCloudRouteImport } from './routes/settings.cloud'
import { Route as SettingsCmmdRouteImport } from './routes/settings.cmmd'
import { Route as SettingsCmmdSyncRouteImport } from './routes/settings.cmmd-sync'
import { Route as SettingsComposerRouteImport } from './routes/settings.composer'
import { Route as SettingsConnectionsRouteImport } from './routes/settings.connections'
import { Route as SettingsDevicesRouteImport } from './routes/settings.devices'
import { Route as SettingsDiagnosticsRouteImport } from './routes/settings.diagnostics'
import { Route as SettingsEditorRouteImport } from './routes/settings.editor'
import { Route as SettingsEnvironmentsRouteImport } from './routes/settings.environments'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsGitRouteImport } from './routes/settings.git'
import { Route as SettingsKeybindingsRouteImport } from './routes/settings.keybindings'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as SettingsProvidersRouteImport } from './routes/settings.providers'
import { Route as SettingsSystemRouteImport } from './routes/settings.system'
import { Route as SettingsThreadsRouteImport } from './routes/settings.threads'
import { Route as SettingsWorkflowRouteImport } from './routes/settings.workflow'
import { Route as ChatEnvironmentIdThreadIdRouteImport } from './routes/_chat.$environmentId.$threadId'
import { Route as ChatAutomationsAutomationIdRouteImport } from './routes/_chat.automations.$automationId'
import { Route as ChatAutomationsNewRouteImport } from './routes/_chat.automations.new'
import { Route as ChatDraftDraftIdRouteImport } from './routes/_chat.draft.$draftId'
import { Route as ChatPluginsIndexRouteImport } from './routes/_chat.plugins.index'
import { Route as ChatPluginsPluginIdRouteImport } from './routes/_chat.plugins.$pluginId'
import { Route as ChatPluginsManageRouteImport } from './routes/_chat.plugins.manage'
import { Route as ChatPluginsSkillsRouteImport } from './routes/_chat.plugins.skills'
import { Route as ChatProjectProjectKeyRouteImport } from './routes/_chat.project.$projectKey'
import { Route as ChatProjectsCmmdProjectIdRouteImport } from './routes/_chat.projects.$cmmdProjectId'
import { Route as ChatAutomationsAutomationIdEditRouteImport } from './routes/_chat.automations.$automationId_.edit'
import { Route as ChatCmmdProjectCmmdProjectIdRouteImport } from './routes/_chat.cmmd.project.$cmmdProjectId'
import { Route as ChatProjectProjectKeyTasksCmmdProjectIdRouteImport } from './routes/_chat.project.$projectKey.tasks.$cmmdProjectId'

const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileRoute = MobileRouteImport.update({
  id: '/mobile',
  path: '/mobile',
  getParentRoute: () => rootRouteImport,
} as any)
const PairRoute = PairRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => rootRouteImport,
} as any)
const PairMachineRoute = PairMachineRouteImport.update({
  id: '/pair-machine',
  path: '/pair-machine',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const ChatAutomationsRoute = ChatAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => ChatRoute,
} as any)
const ChatNewRoute = ChatNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ChatRoute,
} as any)
const ChatPluginsRoute = ChatPluginsRouteImport.update({
  id: '/plugins',
  path: '/plugins',
  getParentRoute: () => ChatRoute,
} as any)
const ChatPullRequestsRoute = ChatPullRequestsRouteImport.update({
  id: '/pull-requests',
  path: '/pull-requests',
  getParentRoute: () => ChatRoute,
} as any)
const SettingsAboutRoute = SettingsAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAgentContextRoute = SettingsAgentContextRouteImport.update({
  id: '/agent-context',
  path: '/agent-context',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAgentWorkflowRoute = SettingsAgentWorkflowRouteImport.update({
  id: '/agent-workflow',
  path: '/agent-workflow',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAgentsRoute = SettingsAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsArchivedRoute = SettingsArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBrowserRoute = SettingsBrowserRouteImport.update({
  id: '/browser',
  path: '/browser',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsChatRoute = SettingsChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCloudRoute = SettingsCloudRouteImport.update({
  id: '/cloud',
  path: '/cloud',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCmmdRoute = SettingsCmmdRouteImport.update({
  id: '/cmmd',
  path: '/cmmd',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCmmdSyncRoute = SettingsCmmdSyncRouteImport.update({
  id: '/cmmd-sync',
  path: '/cmmd-sync',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsComposerRoute = SettingsComposerRouteImport.update({
  id: '/composer',
  path: '/composer',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsConnectionsRoute = SettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDevicesRoute = SettingsDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDiagnosticsRoute = SettingsDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsEditorRoute = SettingsEditorRouteImport.update({
  id: '/editor',
  path: '/editor',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsEnvironmentsRoute = SettingsEnvironmentsRouteImport.update({
  id: '/environments',
  path: '/environments',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGitRoute = SettingsGitRouteImport.update({
  id: '/git',
  path: '/git',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsKeybindingsRoute = SettingsKeybindingsRouteImport.update({
  id: '/keybindings',
  path: '/keybindings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProvidersRoute = SettingsProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSystemRoute = SettingsSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsThreadsRoute = SettingsThreadsRouteImport.update({
  id: '/threads',
  path: '/threads',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsWorkflowRoute = SettingsWorkflowRouteImport.update({
  id: '/workflow',
  path: '/workflow',
  getParentRoute: () => SettingsRoute,
} as any)
const ChatEnvironmentIdThreadIdRoute =
  ChatEnvironmentIdThreadIdRouteImport.update({
    id: '/$environmentId/$threadId',
    path: '/$environmentId/$threadId',
    getParentRoute: () => ChatRoute,
  } as any)
const ChatAutomationsAutomationIdRoute =
  ChatAutomationsAutomationIdRouteImport.update({
    id: '/$automationId',
    path: '/$automationId',
    getParentRoute: () => ChatAutomationsRoute,
  } as any)
const ChatAutomationsNewRoute = ChatAutomationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ChatAutomationsRoute,
} as any)
const ChatDraftDraftIdRoute = ChatDraftDraftIdRouteImport.update({
  id: '/draft/$draftId',
  path: '/draft/$draftId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatPluginsIndexRoute = ChatPluginsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatPluginsRoute,
} as any)
const ChatPluginsPluginIdRoute = ChatPluginsPluginIdRouteImport.update({
  id: '/$pluginId',
  path: '/$pluginId',
  getParentRoute: () => ChatPluginsRoute,
} as any)
const ChatPluginsManageRoute = ChatPluginsManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => ChatPluginsRoute,
} as any)
const ChatPluginsSkillsRoute = ChatPluginsSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => ChatPluginsRoute,
} as any)
const ChatProjectProjectKeyRoute = ChatProjectProjectKeyRouteImport.update({
  id: '/project/$projectKey',
  path: '/project/$projectKey',
  getParentRoute: () => ChatRoute,
} as any)
const ChatProjectsCmmdProjectIdRoute =
  ChatProjectsCmmdProjectIdRouteImport.update({
    id: '/projects/$cmmdProjectId',
    path: '/projects/$cmmdProjectId',
    getParentRoute: () => ChatRoute,
  } as any)
const ChatAutomationsAutomationIdEditRoute =
  ChatAutomationsAutomationIdEditRouteImport.update({
    id: '/$automationId_/edit',
    path: '/$automationId/edit',
    getParentRoute: () => ChatAutomationsRoute,
  } as any)
const ChatCmmdProjectCmmdProjectIdRoute =
  ChatCmmdProjectCmmdProjectIdRouteImport.update({
    id: '/cmmd/project/$cmmdProjectId',
    path: '/cmmd/project/$cmmdProjectId',
    getParentRoute: () => ChatRoute,
  } as any)
const ChatProjectProjectKeyTasksCmmdProjectIdRoute =
  ChatProjectProjectKeyTasksCmmdProjectIdRouteImport.update({
    id: '/tasks/$cmmdProjectId',
    path: '/tasks/$cmmdProjectId',
    getParentRoute: () => ChatProjectProjectKeyRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/login': typeof LoginRoute
  '/mobile': typeof MobileRoute
  '/pair': typeof PairRoute
  '/pair-machine': typeof PairMachineRoute
  '/settings': typeof SettingsRouteWithChildren
  '/setup': typeof SetupRoute
  '/usage': typeof UsageRoute
  '/welcome': typeof WelcomeRoute
  '/automations': typeof ChatAutomationsRouteWithChildren
  '/new': typeof ChatNewRoute
  '/plugins': typeof ChatPluginsRouteWithChildren
  '/pull-requests': typeof ChatPullRequestsRoute
  '/settings/about': typeof SettingsAboutRoute
  '/settings/agent-context': typeof SettingsAgentContextRoute
  '/settings/agent-workflow': typeof SettingsAgentWorkflowRoute
  '/settings/agents': typeof SettingsAgentsRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/browser': typeof SettingsBrowserRoute
  '/settings/chat': typeof SettingsChatRoute
  '/settings/cloud': typeof SettingsCloudRoute
  '/settings/cmmd': typeof SettingsCmmdRoute
  '/settings/cmmd-sync': typeof SettingsCmmdSyncRoute
  '/settings/composer': typeof SettingsComposerRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/editor': typeof SettingsEditorRoute
  '/settings/environments': typeof SettingsEnvironmentsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/git': typeof SettingsGitRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/system': typeof SettingsSystemRoute
  '/settings/threads': typeof SettingsThreadsRoute
  '/settings/workflow': typeof SettingsWorkflowRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/automations/$automationId': typeof ChatAutomationsAutomationIdRoute
  '/automations/new': typeof ChatAutomationsNewRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/plugins/$pluginId': typeof ChatPluginsPluginIdRoute
  '/plugins/manage': typeof ChatPluginsManageRoute
  '/plugins/skills': typeof ChatPluginsSkillsRoute
  '/project/$projectKey': typeof ChatProjectProjectKeyRouteWithChildren
  '/projects/$cmmdProjectId': typeof ChatProjectsCmmdProjectIdRoute
  '/plugins/': typeof ChatPluginsIndexRoute
  '/automations/$automationId/edit': typeof ChatAutomationsAutomationIdEditRoute
  '/cmmd/project/$cmmdProjectId': typeof ChatCmmdProjectCmmdProjectIdRoute
  '/project/$projectKey/tasks/$cmmdProjectId': typeof ChatProjectProjectKeyTasksCmmdProjectIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/mobile': typeof MobileRoute
  '/pair': typeof PairRoute
  '/pair-machine': typeof PairMachineRoute
  '/settings': typeof SettingsRouteWithChildren
  '/setup': typeof SetupRoute
  '/usage': typeof UsageRoute
  '/welcome': typeof WelcomeRoute
  '/automations': typeof ChatAutomationsRouteWithChildren
  '/new': typeof ChatNewRoute
  '/pull-requests': typeof ChatPullRequestsRoute
  '/settings/about': typeof SettingsAboutRoute
  '/settings/agent-context': typeof SettingsAgentContextRoute
  '/settings/agent-workflow': typeof SettingsAgentWorkflowRoute
  '/settings/agents': typeof SettingsAgentsRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/browser': typeof SettingsBrowserRoute
  '/settings/chat': typeof SettingsChatRoute
  '/settings/cloud': typeof SettingsCloudRoute
  '/settings/cmmd': typeof SettingsCmmdRoute
  '/settings/cmmd-sync': typeof SettingsCmmdSyncRoute
  '/settings/composer': typeof SettingsComposerRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/editor': typeof SettingsEditorRoute
  '/settings/environments': typeof SettingsEnvironmentsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/git': typeof SettingsGitRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/system': typeof SettingsSystemRoute
  '/settings/threads': typeof SettingsThreadsRoute
  '/settings/workflow': typeof SettingsWorkflowRoute
  '/': typeof ChatIndexRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/automations/$automationId': typeof ChatAutomationsAutomationIdRoute
  '/automations/new': typeof ChatAutomationsNewRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/plugins/$pluginId': typeof ChatPluginsPluginIdRoute
  '/plugins/manage': typeof ChatPluginsManageRoute
  '/plugins/skills': typeof ChatPluginsSkillsRoute
  '/project/$projectKey': typeof ChatProjectProjectKeyRouteWithChildren
  '/projects/$cmmdProjectId': typeof ChatProjectsCmmdProjectIdRoute
  '/plugins': typeof ChatPluginsIndexRoute
  '/automations/$automationId/edit': typeof ChatAutomationsAutomationIdEditRoute
  '/cmmd/project/$cmmdProjectId': typeof ChatCmmdProjectCmmdProjectIdRoute
  '/project/$projectKey/tasks/$cmmdProjectId': typeof ChatProjectProjectKeyTasksCmmdProjectIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/login': typeof LoginRoute
  '/mobile': typeof MobileRoute
  '/pair': typeof PairRoute
  '/pair-machine': typeof PairMachineRoute
  '/settings': typeof SettingsRouteWithChildren
  '/setup': typeof SetupRoute
  '/usage': typeof UsageRoute
  '/welcome': typeof WelcomeRoute
  '/_chat/automations': typeof ChatAutomationsRouteWithChildren
  '/_chat/new': typeof ChatNewRoute
  '/_chat/plugins': typeof ChatPluginsRouteWithChildren
  '/_chat/pull-requests': typeof ChatPullRequestsRoute
  '/settings/about': typeof SettingsAboutRoute
  '/settings/agent-context': typeof SettingsAgentContextRoute
  '/settings/agent-workflow': typeof SettingsAgentWorkflowRoute
  '/settings/agents': typeof SettingsAgentsRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/browser': typeof SettingsBrowserRoute
  '/settings/chat': typeof SettingsChatRoute
  '/settings/cloud': typeof SettingsCloudRoute
  '/settings/cmmd': typeof SettingsCmmdRoute
  '/settings/cmmd-sync': typeof SettingsCmmdSyncRoute
  '/settings/composer': typeof SettingsComposerRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/editor': typeof SettingsEditorRoute
  '/settings/environments': typeof SettingsEnvironmentsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/git': typeof SettingsGitRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/system': typeof SettingsSystemRoute
  '/settings/threads': typeof SettingsThreadsRoute
  '/settings/workflow': typeof SettingsWorkflowRoute
  '/_chat/': typeof ChatIndexRoute
  '/_chat/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/_chat/automations/$automationId': typeof ChatAutomationsAutomationIdRoute
  '/_chat/automations/new': typeof ChatAutomationsNewRoute
  '/_chat/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/_chat/plugins/$pluginId': typeof ChatPluginsPluginIdRoute
  '/_chat/plugins/manage': typeof ChatPluginsManageRoute
  '/_chat/plugins/skills': typeof ChatPluginsSkillsRoute
  '/_chat/project/$projectKey': typeof ChatProjectProjectKeyRouteWithChildren
  '/_chat/projects/$cmmdProjectId': typeof ChatProjectsCmmdProjectIdRoute
  '/_chat/plugins/': typeof ChatPluginsIndexRoute
  '/_chat/automations/$automationId_/edit': typeof ChatAutomationsAutomationIdEditRoute
  '/_chat/cmmd/project/$cmmdProjectId': typeof ChatCmmdProjectCmmdProjectIdRoute
  '/_chat/project/$projectKey/tasks/$cmmdProjectId': typeof ChatProjectProjectKeyTasksCmmdProjectIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/mobile'
    | '/pair'
    | '/pair-machine'
    | '/settings'
    | '/setup'
    | '/usage'
    | '/welcome'
    | '/automations'
    | '/new'
    | '/plugins'
    | '/pull-requests'
    | '/settings/about'
    | '/settings/agent-context'
    | '/settings/agent-workflow'
    | '/settings/agents'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/browser'
    | '/settings/chat'
    | '/settings/cloud'
    | '/settings/cmmd'
    | '/settings/cmmd-sync'
    | '/settings/composer'
    | '/settings/connections'
    | '/settings/devices'
    | '/settings/diagnostics'
    | '/settings/editor'
    | '/settings/environments'
    | '/settings/general'
    | '/settings/git'
    | '/settings/keybindings'
    | '/settings/profile'
    | '/settings/providers'
    | '/settings/system'
    | '/settings/threads'
    | '/settings/workflow'
    | '/$environmentId/$threadId'
    | '/automations/$automationId'
    | '/automations/new'
    | '/draft/$draftId'
    | '/plugins/$pluginId'
    | '/plugins/manage'
    | '/plugins/skills'
    | '/project/$projectKey'
    | '/projects/$cmmdProjectId'
    | '/plugins/'
    | '/automations/$automationId/edit'
    | '/cmmd/project/$cmmdProjectId'
    | '/project/$projectKey/tasks/$cmmdProjectId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/mobile'
    | '/pair'
    | '/pair-machine'
    | '/settings'
    | '/setup'
    | '/usage'
    | '/welcome'
    | '/automations'
    | '/new'
    | '/pull-requests'
    | '/settings/about'
    | '/settings/agent-context'
    | '/settings/agent-workflow'
    | '/settings/agents'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/browser'
    | '/settings/chat'
    | '/settings/cloud'
    | '/settings/cmmd'
    | '/settings/cmmd-sync'
    | '/settings/composer'
    | '/settings/connections'
    | '/settings/devices'
    | '/settings/diagnostics'
    | '/settings/editor'
    | '/settings/environments'
    | '/settings/general'
    | '/settings/git'
    | '/settings/keybindings'
    | '/settings/profile'
    | '/settings/providers'
    | '/settings/system'
    | '/settings/threads'
    | '/settings/workflow'
    | '/'
    | '/$environmentId/$threadId'
    | '/automations/$automationId'
    | '/automations/new'
    | '/draft/$draftId'
    | '/plugins/$pluginId'
    | '/plugins/manage'
    | '/plugins/skills'
    | '/project/$projectKey'
    | '/projects/$cmmdProjectId'
    | '/plugins'
    | '/automations/$automationId/edit'
    | '/cmmd/project/$cmmdProjectId'
    | '/project/$projectKey/tasks/$cmmdProjectId'
  id:
    | '__root__'
    | '/_chat'
    | '/login'
    | '/mobile'
    | '/pair'
    | '/pair-machine'
    | '/settings'
    | '/setup'
    | '/usage'
    | '/welcome'
    | '/_chat/automations'
    | '/_chat/new'
    | '/_chat/plugins'
    | '/_chat/pull-requests'
    | '/settings/about'
    | '/settings/agent-context'
    | '/settings/agent-workflow'
    | '/settings/agents'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/browser'
    | '/settings/chat'
    | '/settings/cloud'
    | '/settings/cmmd'
    | '/settings/cmmd-sync'
    | '/settings/composer'
    | '/settings/connections'
    | '/settings/devices'
    | '/settings/diagnostics'
    | '/settings/editor'
    | '/settings/environments'
    | '/settings/general'
    | '/settings/git'
    | '/settings/keybindings'
    | '/settings/profile'
    | '/settings/providers'
    | '/settings/system'
    | '/settings/threads'
    | '/settings/workflow'
    | '/_chat/'
    | '/_chat/$environmentId/$threadId'
    | '/_chat/automations/$automationId'
    | '/_chat/automations/new'
    | '/_chat/draft/$draftId'
    | '/_chat/plugins/$pluginId'
    | '/_chat/plugins/manage'
    | '/_chat/plugins/skills'
    | '/_chat/project/$projectKey'
    | '/_chat/projects/$cmmdProjectId'
    | '/_chat/plugins/'
    | '/_chat/automations/$automationId_/edit'
    | '/_chat/cmmd/project/$cmmdProjectId'
    | '/_chat/project/$projectKey/tasks/$cmmdProjectId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  LoginRoute: typeof LoginRoute
  MobileRoute: typeof MobileRoute
  PairRoute: typeof PairRoute
  PairMachineRoute: typeof PairMachineRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  SetupRoute: typeof SetupRoute
  UsageRoute: typeof UsageRoute
  WelcomeRoute: typeof WelcomeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile': {
      id: '/mobile'
      path: '/mobile'
      fullPath: '/mobile'
      preLoaderRoute: typeof MobileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair': {
      id: '/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof PairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair-machine': {
      id: '/pair-machine'
      path: '/pair-machine'
      fullPath: '/pair-machine'
      preLoaderRoute: typeof PairMachineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/automations': {
      id: '/_chat/automations'
      path: '/automations'
      fullPath: '/automations'
      preLoaderRoute: typeof ChatAutomationsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/new': {
      id: '/_chat/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof ChatNewRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/plugins': {
      id: '/_chat/plugins'
      path: '/plugins'
      fullPath: '/plugins'
      preLoaderRoute: typeof ChatPluginsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/pull-requests': {
      id: '/_chat/pull-requests'
      path: '/pull-requests'
      fullPath: '/pull-requests'
      preLoaderRoute: typeof ChatPullRequestsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/settings/about': {
      id: '/settings/about'
      path: '/about'
      fullPath: '/settings/about'
      preLoaderRoute: typeof SettingsAboutRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/agent-context': {
      id: '/settings/agent-context'
      path: '/agent-context'
      fullPath: '/settings/agent-context'
      preLoaderRoute: typeof SettingsAgentContextRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/agent-workflow': {
      id: '/settings/agent-workflow'
      path: '/agent-workflow'
      fullPath: '/settings/agent-workflow'
      preLoaderRoute: typeof SettingsAgentWorkflowRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/agents': {
      id: '/settings/agents'
      path: '/agents'
      fullPath: '/settings/agents'
      preLoaderRoute: typeof SettingsAgentsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/archived': {
      id: '/settings/archived'
      path: '/archived'
      fullPath: '/settings/archived'
      preLoaderRoute: typeof SettingsArchivedRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/browser': {
      id: '/settings/browser'
      path: '/browser'
      fullPath: '/settings/browser'
      preLoaderRoute: typeof SettingsBrowserRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/chat': {
      id: '/settings/chat'
      path: '/chat'
      fullPath: '/settings/chat'
      preLoaderRoute: typeof SettingsChatRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/cloud': {
      id: '/settings/cloud'
      path: '/cloud'
      fullPath: '/settings/cloud'
      preLoaderRoute: typeof SettingsCloudRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/cmmd': {
      id: '/settings/cmmd'
      path: '/cmmd'
      fullPath: '/settings/cmmd'
      preLoaderRoute: typeof SettingsCmmdRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/cmmd-sync': {
      id: '/settings/cmmd-sync'
      path: '/cmmd-sync'
      fullPath: '/settings/cmmd-sync'
      preLoaderRoute: typeof SettingsCmmdSyncRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/composer': {
      id: '/settings/composer'
      path: '/composer'
      fullPath: '/settings/composer'
      preLoaderRoute: typeof SettingsComposerRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/connections': {
      id: '/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof SettingsConnectionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/devices': {
      id: '/settings/devices'
      path: '/devices'
      fullPath: '/settings/devices'
      preLoaderRoute: typeof SettingsDevicesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/diagnostics': {
      id: '/settings/diagnostics'
      path: '/diagnostics'
      fullPath: '/settings/diagnostics'
      preLoaderRoute: typeof SettingsDiagnosticsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/editor': {
      id: '/settings/editor'
      path: '/editor'
      fullPath: '/settings/editor'
      preLoaderRoute: typeof SettingsEditorRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/environments': {
      id: '/settings/environments'
      path: '/environments'
      fullPath: '/settings/environments'
      preLoaderRoute: typeof SettingsEnvironmentsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/git': {
      id: '/settings/git'
      path: '/git'
      fullPath: '/settings/git'
      preLoaderRoute: typeof SettingsGitRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/keybindings': {
      id: '/settings/keybindings'
      path: '/keybindings'
      fullPath: '/settings/keybindings'
      preLoaderRoute: typeof SettingsKeybindingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/providers': {
      id: '/settings/providers'
      path: '/providers'
      fullPath: '/settings/providers'
      preLoaderRoute: typeof SettingsProvidersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/system': {
      id: '/settings/system'
      path: '/system'
      fullPath: '/settings/system'
      preLoaderRoute: typeof SettingsSystemRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/threads': {
      id: '/settings/threads'
      path: '/threads'
      fullPath: '/settings/threads'
      preLoaderRoute: typeof SettingsThreadsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/workflow': {
      id: '/settings/workflow'
      path: '/workflow'
      fullPath: '/settings/workflow'
      preLoaderRoute: typeof SettingsWorkflowRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_chat/$environmentId/$threadId': {
      id: '/_chat/$environmentId/$threadId'
      path: '/$environmentId/$threadId'
      fullPath: '/$environmentId/$threadId'
      preLoaderRoute: typeof ChatEnvironmentIdThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/automations/$automationId': {
      id: '/_chat/automations/$automationId'
      path: '/$automationId'
      fullPath: '/automations/$automationId'
      preLoaderRoute: typeof ChatAutomationsAutomationIdRouteImport
      parentRoute: typeof ChatAutomationsRoute
    }
    '/_chat/automations/new': {
      id: '/_chat/automations/new'
      path: '/new'
      fullPath: '/automations/new'
      preLoaderRoute: typeof ChatAutomationsNewRouteImport
      parentRoute: typeof ChatAutomationsRoute
    }
    '/_chat/draft/$draftId': {
      id: '/_chat/draft/$draftId'
      path: '/draft/$draftId'
      fullPath: '/draft/$draftId'
      preLoaderRoute: typeof ChatDraftDraftIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/plugins/': {
      id: '/_chat/plugins/'
      path: '/'
      fullPath: '/plugins/'
      preLoaderRoute: typeof ChatPluginsIndexRouteImport
      parentRoute: typeof ChatPluginsRoute
    }
    '/_chat/plugins/$pluginId': {
      id: '/_chat/plugins/$pluginId'
      path: '/$pluginId'
      fullPath: '/plugins/$pluginId'
      preLoaderRoute: typeof ChatPluginsPluginIdRouteImport
      parentRoute: typeof ChatPluginsRoute
    }
    '/_chat/plugins/manage': {
      id: '/_chat/plugins/manage'
      path: '/manage'
      fullPath: '/plugins/manage'
      preLoaderRoute: typeof ChatPluginsManageRouteImport
      parentRoute: typeof ChatPluginsRoute
    }
    '/_chat/plugins/skills': {
      id: '/_chat/plugins/skills'
      path: '/skills'
      fullPath: '/plugins/skills'
      preLoaderRoute: typeof ChatPluginsSkillsRouteImport
      parentRoute: typeof ChatPluginsRoute
    }
    '/_chat/project/$projectKey': {
      id: '/_chat/project/$projectKey'
      path: '/project/$projectKey'
      fullPath: '/project/$projectKey'
      preLoaderRoute: typeof ChatProjectProjectKeyRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/projects/$cmmdProjectId': {
      id: '/_chat/projects/$cmmdProjectId'
      path: '/projects/$cmmdProjectId'
      fullPath: '/projects/$cmmdProjectId'
      preLoaderRoute: typeof ChatProjectsCmmdProjectIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/automations/$automationId_/edit': {
      id: '/_chat/automations/$automationId_/edit'
      path: '/$automationId/edit'
      fullPath: '/automations/$automationId/edit'
      preLoaderRoute: typeof ChatAutomationsAutomationIdEditRouteImport
      parentRoute: typeof ChatAutomationsRoute
    }
    '/_chat/cmmd/project/$cmmdProjectId': {
      id: '/_chat/cmmd/project/$cmmdProjectId'
      path: '/cmmd/project/$cmmdProjectId'
      fullPath: '/cmmd/project/$cmmdProjectId'
      preLoaderRoute: typeof ChatCmmdProjectCmmdProjectIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/project/$projectKey/tasks/$cmmdProjectId': {
      id: '/_chat/project/$projectKey/tasks/$cmmdProjectId'
      path: '/tasks/$cmmdProjectId'
      fullPath: '/project/$projectKey/tasks/$cmmdProjectId'
      preLoaderRoute: typeof ChatProjectProjectKeyTasksCmmdProjectIdRouteImport
      parentRoute: typeof ChatProjectProjectKeyRoute
    }
  }
}

interface ChatAutomationsRouteChildren {
  ChatAutomationsAutomationIdRoute: typeof ChatAutomationsAutomationIdRoute
  ChatAutomationsNewRoute: typeof ChatAutomationsNewRoute
  ChatAutomationsAutomationIdEditRoute: typeof ChatAutomationsAutomationIdEditRoute
}

const ChatAutomationsRouteChildren: ChatAutomationsRouteChildren = {
  ChatAutomationsAutomationIdRoute: ChatAutomationsAutomationIdRoute,
  ChatAutomationsNewRoute: ChatAutomationsNewRoute,
  ChatAutomationsAutomationIdEditRoute: ChatAutomationsAutomationIdEditRoute,
}

const ChatAutomationsRouteWithChildren = ChatAutomationsRoute._addFileChildren(
  ChatAutomationsRouteChildren,
)

interface ChatPluginsRouteChildren {
  ChatPluginsPluginIdRoute: typeof ChatPluginsPluginIdRoute
  ChatPluginsManageRoute: typeof ChatPluginsManageRoute
  ChatPluginsSkillsRoute: typeof ChatPluginsSkillsRoute
  ChatPluginsIndexRoute: typeof ChatPluginsIndexRoute
}

const ChatPluginsRouteChildren: ChatPluginsRouteChildren = {
  ChatPluginsPluginIdRoute: ChatPluginsPluginIdRoute,
  ChatPluginsManageRoute: ChatPluginsManageRoute,
  ChatPluginsSkillsRoute: ChatPluginsSkillsRoute,
  ChatPluginsIndexRoute: ChatPluginsIndexRoute,
}

const ChatPluginsRouteWithChildren = ChatPluginsRoute._addFileChildren(
  ChatPluginsRouteChildren,
)

interface ChatProjectProjectKeyRouteChildren {
  ChatProjectProjectKeyTasksCmmdProjectIdRoute: typeof ChatProjectProjectKeyTasksCmmdProjectIdRoute
}

const ChatProjectProjectKeyRouteChildren: ChatProjectProjectKeyRouteChildren = {
  ChatProjectProjectKeyTasksCmmdProjectIdRoute:
    ChatProjectProjectKeyTasksCmmdProjectIdRoute,
}

const ChatProjectProjectKeyRouteWithChildren =
  ChatProjectProjectKeyRoute._addFileChildren(
    ChatProjectProjectKeyRouteChildren,
  )

interface ChatRouteChildren {
  ChatAutomationsRoute: typeof ChatAutomationsRouteWithChildren
  ChatNewRoute: typeof ChatNewRoute
  ChatPluginsRoute: typeof ChatPluginsRouteWithChildren
  ChatPullRequestsRoute: typeof ChatPullRequestsRoute
  ChatIndexRoute: typeof ChatIndexRoute
  ChatEnvironmentIdThreadIdRoute: typeof ChatEnvironmentIdThreadIdRoute
  ChatDraftDraftIdRoute: typeof ChatDraftDraftIdRoute
  ChatProjectProjectKeyRoute: typeof ChatProjectProjectKeyRouteWithChildren
  ChatProjectsCmmdProjectIdRoute: typeof ChatProjectsCmmdProjectIdRoute
  ChatCmmdProjectCmmdProjectIdRoute: typeof ChatCmmdProjectCmmdProjectIdRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatAutomationsRoute: ChatAutomationsRouteWithChildren,
  ChatNewRoute: ChatNewRoute,
  ChatPluginsRoute: ChatPluginsRouteWithChildren,
  ChatPullRequestsRoute: ChatPullRequestsRoute,
  ChatIndexRoute: ChatIndexRoute,
  ChatEnvironmentIdThreadIdRoute: ChatEnvironmentIdThreadIdRoute,
  ChatDraftDraftIdRoute: ChatDraftDraftIdRoute,
  ChatProjectProjectKeyRoute: ChatProjectProjectKeyRouteWithChildren,
  ChatProjectsCmmdProjectIdRoute: ChatProjectsCmmdProjectIdRoute,
  ChatCmmdProjectCmmdProjectIdRoute: ChatCmmdProjectCmmdProjectIdRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface SettingsRouteChildren {
  SettingsAboutRoute: typeof SettingsAboutRoute
  SettingsAgentContextRoute: typeof SettingsAgentContextRoute
  SettingsAgentWorkflowRoute: typeof SettingsAgentWorkflowRoute
  SettingsAgentsRoute: typeof SettingsAgentsRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsArchivedRoute: typeof SettingsArchivedRoute
  SettingsBrowserRoute: typeof SettingsBrowserRoute
  SettingsChatRoute: typeof SettingsChatRoute
  SettingsCloudRoute: typeof SettingsCloudRoute
  SettingsCmmdRoute: typeof SettingsCmmdRoute
  SettingsCmmdSyncRoute: typeof SettingsCmmdSyncRoute
  SettingsComposerRoute: typeof SettingsComposerRoute
  SettingsConnectionsRoute: typeof SettingsConnectionsRoute
  SettingsDevicesRoute: typeof SettingsDevicesRoute
  SettingsDiagnosticsRoute: typeof SettingsDiagnosticsRoute
  SettingsEditorRoute: typeof SettingsEditorRoute
  SettingsEnvironmentsRoute: typeof SettingsEnvironmentsRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsGitRoute: typeof SettingsGitRoute
  SettingsKeybindingsRoute: typeof SettingsKeybindingsRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsProvidersRoute: typeof SettingsProvidersRoute
  SettingsSystemRoute: typeof SettingsSystemRoute
  SettingsThreadsRoute: typeof SettingsThreadsRoute
  SettingsWorkflowRoute: typeof SettingsWorkflowRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAboutRoute: SettingsAboutRoute,
  SettingsAgentContextRoute: SettingsAgentContextRoute,
  SettingsAgentWorkflowRoute: SettingsAgentWorkflowRoute,
  SettingsAgentsRoute: SettingsAgentsRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsArchivedRoute: SettingsArchivedRoute,
  SettingsBrowserRoute: SettingsBrowserRoute,
  SettingsChatRoute: SettingsChatRoute,
  SettingsCloudRoute: SettingsCloudRoute,
  SettingsCmmdRoute: SettingsCmmdRoute,
  SettingsCmmdSyncRoute: SettingsCmmdSyncRoute,
  SettingsComposerRoute: SettingsComposerRoute,
  SettingsConnectionsRoute: SettingsConnectionsRoute,
  SettingsDevicesRoute: SettingsDevicesRoute,
  SettingsDiagnosticsRoute: SettingsDiagnosticsRoute,
  SettingsEditorRoute: SettingsEditorRoute,
  SettingsEnvironmentsRoute: SettingsEnvironmentsRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsGitRoute: SettingsGitRoute,
  SettingsKeybindingsRoute: SettingsKeybindingsRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsProvidersRoute: SettingsProvidersRoute,
  SettingsSystemRoute: SettingsSystemRoute,
  SettingsThreadsRoute: SettingsThreadsRoute,
  SettingsWorkflowRoute: SettingsWorkflowRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  LoginRoute: LoginRoute,
  MobileRoute: MobileRoute,
  PairRoute: PairRoute,
  PairMachineRoute: PairMachineRoute,
  SettingsRoute: SettingsRouteWithChildren,
  SetupRoute: SetupRoute,
  UsageRoute: UsageRoute,
  WelcomeRoute: WelcomeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
